export function ProgressBar({ progress }: { progress: number }) {
  return (
    <div className="w-full bg-blue-100 dark:bg-blue-950 rounded-lg overflow-hidden h-5">
      <div
        className="h-full flex items-center justify-center font-semibold text-xs
                   text-white transition-all bg-blue-500 rounded-lg"
        style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
      ></div>
    </div>
  );
}
